<template>
  <div class="nav-sm font-family">
    <div class="container body serviceMain__body">
      <TopNavbar></TopNavbar>
      <router-view></router-view>
    </div>
    <footer class="footer">
      <p class="footer__text">資通行動科技{{ VERSION }}</p>
    </footer>
  </div>
</template>
<script>
import TopNavbar from '@/components/TopNavbar'
import { mapActions } from 'vuex'
import { appVersion } from '@/constants/general'

export default {
  name: 'ServiceMain',
  data() {
    return {
      VERSION: appVersion,
    }
  },
  methods: {
    ...mapActions({
      fetchManagerList: 'managerStore/fetchManagerList',
      fetchPositionList: 'positionStore/fetchPositionList',
      fetServiceList: 'serviceStore/fetchServiceList',
      fethAuthList: 'adminPermissionStore/fetchAdminPermission',
    }),
  },
  components: {
    TopNavbar,
  },
  async created() {
    try {
      await this.fetServiceList()
      await this.fetchManagerList()
      await this.fetchPositionList()
      await this.fethAuthList()
    } catch (error) {
      console.error(error)
    }
  },
}
</script>
<style lang="scss" scoped>
.serviceMain {
  &__body {
    min-height: calc(100vh - 30px);
  }
}

.footer {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &__text {
    margin: 0;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ServiceMain.vue